import "./video.css"
const VideoModal = ({children,showVideoModal}) => {
  return (
    <div className={showVideoModal ? "video-modal" : ""}>
        {children}
    </div>
  )
}

export default VideoModal